import type { SharedProjectRouter } from "replo-publisher/src/trpc/routers/sharedProject";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: sharedProjectRouter,
  client: sharedProjectClient,
  utils: sharedProjectUtils,
  options: sharedProjectOptions,
} = createTrpcRouterConfig<SharedProjectRouter>({
  path: "sharedProject",
  queryClient: getNamespacedQueryClient("sharedProject"),
});

export {
  sharedProjectClient,
  sharedProjectRouter,
  sharedProjectUtils,
  sharedProjectOptions,
};
